import { ClassNames, css, keyframes } from '@emotion/react';
import { Tag, type TagProps } from 'antd';

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const shimmerStyle = css`
  background: linear-gradient(
      110deg,
      #171717 0%,
      #171717 38%,
      #9ca3af 44%,
      #e5e7eb 50%,
      #9ca3af 56%,
      #171717 62%,
      #171717 100%
    )
    0 0 / 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${shimmer} 2s linear infinite;
`;

export const StatusTag = ({
  active,
  ...props
}: TagProps & { active?: boolean }) => {
  return (
    <ClassNames>
      {({ cx, css }) => (
        <Tag
          className="text-sm"
          classNames={{
            content: cx({
              [css`
                ${shimmerStyle}
              `]: active,
            }),
          }}
          {...props}
        ></Tag>
      )}
    </ClassNames>
  );
};
